import React from 'react';

import MerchantSelect from '@components/operator/MerchantSelect';
import PageHeader from '@shared/PageHeader';
import { useOperatorData } from '@contexts/operator/OperatorDataContext';
import useOperatorProductLabelTemplateService from '@hooks/operator/product_label_templates/useOperatorProductLabelTemplateService';
import { useOperatorProductService } from '@hooks/operator/products/useOperatorProductService';
import ProductLabelTemplatesEdit from '@shared/product_label_templates/ProductLabelTemplatesEdit';

const ProductLabelTemplatesNewContent: React.FC = () => {
  // useOperatorProductLabelTemplateService 是 .js 且 JSDoc 標 `@returns {Object}`，
  // TS 看不到方法欄位，cast 為 any 保留 runtime 行為。
  const {
    getById,
    create,
    update,
    getDefaultTemplate,
  } = useOperatorProductLabelTemplateService() as any;
  const productService = useOperatorProductService();
  const { merchantId } = useOperatorData();

  // MerchantSelect 已 gate 住 merchantId 必有；此處 narrow 為 runtime invariant，
  // 避免把 null 傳進 ProductLabelTemplatesEdit 導致 ProductSelect 用 null filter →
  // BE products#index 回傳所有 accessible merchants 的 products（UX bug）。
  if (!merchantId) return null;

  return (
    <div>
      <PageHeader items={['products', 'products.label_templates', 'products.label_templates.new']} />
      <ProductLabelTemplatesEdit
        role="operator"
        getById={getById}
        create={create}
        update={update}
        getDefaultTemplate={getDefaultTemplate}
        productService={productService}
        merchantIdForFilters={merchantId}
      />
    </div>
  );
};

const OperatorProductLabelTemplateNew: React.FC = () => {
  return (
    <MerchantSelect>
      <ProductLabelTemplatesNewContent />
    </MerchantSelect>
  );
};

export default OperatorProductLabelTemplateNew;
